/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum NegotiationContractualAmendmentAliases {
  ACTION_REQUEST_CHANGE = 'action-request-change',
  AUTOCOMPLETE_MENU_MOBILE = 'autocomplete-menu-mobile',
  BREADCRUMB_CONTRACTUAL_DRAFT = 'breadcrumb-contractual-draft',
  CONTEXTUAL_BAR_CLAUSE = 'contextual-bar-clause',
  DROP_DOWN_MENU_0 = 'drop-down-menu-0',
  FETCH_0 = 'fetch-0',
  FETCH_CLAUSE = 'fetch-clause',
  FETCH_CLAUSES = 'fetch-clauses',
  FETCH_MENU_MOBILE = 'fetch-menu-mobile',
  FIELD_0 = 'field-0',
  FIELD_2 = 'field-2',
  FIELD_3 = 'field-3',
  FIELD_ATTACHMENT = 'field-attachment',
  FIELD_BULLET = 'field-bullet',
  FIELD_CLAUSES = 'field-clauses',
  FIELD_COUNTER_OFFER = 'field-counter-offer',
  FIELD_FILTER = 'field-filter',
  FIELD_MESSAGE_REQUEST_CHANGE = 'field-message-request-change',
  FIELD_PROPOSAL = 'field-proposal',
  FORM_0 = 'form-0',
  FORM_1 = 'form-1',
  FORM_MENU_MOBILE = 'form-menu-mobile',
  FORM_REQUEST_CHANGE = 'form-request-change',
  FRAGMENT_0 = 'fragment-0',
  FRAGMENT_1 = 'fragment-1',
  HPMS_TEXT_HTML_0 = 'hpms-text-html-0',
  HPMS_TEXT_HTML_COUNTER_OFFER = 'hpms-text-html-counter-offer',
  INPUT_FILTER = 'input-filter',
  LAYOUT_0 = 'layout-0',
  LAYOUT_CLAUSE = 'layout-clause',
  LAYOUT_CONTRACTUAL_BAR = 'layout-contractual-bar',
  LINK_ATTACHMENT = 'link-attachment',
  LINK_PROPOSAL = 'link-proposal',
  LOADER_0 = 'loader-0',
  MAPPER_0 = 'mapper-0',
  MAPPER_1 = 'mapper-1',
  MAPPER_ATTACHMENT = 'mapper-attachment',
  MODAL_REQUEST_CHANGE = 'modal-request-change',
  PANEL_0 = 'panel-0',
  PANEL_1 = 'panel-1',
  PANEL_2 = 'panel-2',
  PANEL_ATTACHMENTS = 'panel-attachments',
  PANEL_CLAUSE = 'panel-clause',
  PANEL_CONTRACTUAL_DRAFT = 'panel-contractual-draft',
  PANEL_FILTER = 'panel-filter',
  PANEL_LEVEL = 'panel-level',
  PANEL_LOADER = 'panel-loader',
  PANEL_MOBILE = 'panel-mobile',
  PANEL_PROPOSAL = 'panel-proposal',
  PANEL_REPEATER = 'panel-repeater',
  PANEL_REQUEST_CHANGE = 'panel-request-change',
  PANEL_SIDEBAR = 'panel-sidebar',
  PANEL_TITLE = 'panel-title',
  REPEATER_0 = 'repeater-0',
  REPEATER_REQUEST_DIAGNOSIS = 'repeater-request-diagnosis',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
  TEXT_AREA_REQUEST_CHANGE = 'text-area-request-change',
  TEXT_DROP = 'text-drop',
  TOKEN_AMENDMENT_TYPE = 'token-amendment-type',
  TOKEN_STATUS = 'token-status',
}
export { NegotiationContractualAmendmentAliases };
